/**
 * What a picture of the board holds, drawn out of sight at full size (`#board-export`) for
 * `html-to-image` to make a PNG of (`picture.ts`): the frames, arrows and items of the area.
 */
import { For, Show, createMemo, type JSX } from "solid-js";
import { useApp } from "../../../app/context";
import { Arrows } from "./Arrows";
import { BoardItem } from "./BoardItem";
import { Frame } from "./Frame";
import type { ExportArea } from "./picture";
import { FRAME_TITLE_PX } from "./constants";

/** The area drawn; `ref` gets the element made a picture. */
export function ExportLayer(props: { area: ExportArea; ref: (el: HTMLDivElement) => void }): JSX.Element {
  const { board } = useApp();
  const itemById = createMemo(() => new Map(board.content().items.map((i) => [i.id, i])));
  const frameById = createMemo(() => new Map(board.content().frames.map((f) => [f.id, f])));
  const area = () => props.area;
  return (
    <div class="board-export" id="board-export" aria-hidden="true">
      <div ref={props.ref} class="board-picture" style={{ width: `${area().box.w}px`, height: `${area().box.h}px` }}>
        <div class="board-layer" style={{ transform: `translate(${-area().box.x}px, ${-area().box.y}px)` }}>
          <For each={area().frames}>{(id) => <Show when={frameById().get(id)}>{(f) => <Frame frame={f()} selected={false} titlePx={FRAME_TITLE_PX} editing={false} done={() => {}} />}</Show>}</For>
          <Arrows only={area().ids} />
          <For each={area().items}>{(id) => <Show when={itemById().get(id)}>{(item) => <BoardItem id={id} node={item().node} place={item().place} selected={false} editing={false} done={() => {}} />}</Show>}</For>
        </div>
      </div>
    </div>
  );
}
